import { render, staticRenderFns } from "./ValidatorPickerWindow.vue?vue&type=template&id=10f77cd0&"
import script from "./ValidatorPickerWindow.vue?vue&type=script&lang=js&"
export * from "./ValidatorPickerWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports